import React, { Component } from 'react';
import { TouchableOpacity } from 'react-native';
import Icon from '../../Icon';
import styles from './style';
class BackToTop extends Component<{ showBackToTop?: boolean; onPress(): void }> {

    public render() {
        const { showBackToTop,onPress } = this.props;
        if (!showBackToTop) {
            return null;
        }
        return (
            <TouchableOpacity activeOpacity={1} onPress={onPress} style={styles.backToTopBtn}>
                <Icon code="&#xf3a4;" size={20} style={styles.backToTopBtnIcon} />
            </TouchableOpacity>
        );
    }
}

export default BackToTop;
